export default __webpack_public_path__ + "static/media/Mergers-and-Acquisitions.199fcca5.svg";